import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Reusable Components
import CheckList_TwoColumns from "reusables/TextFormats/CheckList_TwoColumns";

// Images

function Full_Section2() {
  const titlesDescriptionsObj = {
    "All services included in the ‘Let Only’ Property Service": "",
    "Rent collection and arrears management": "",
    "Routine property inspections with detailed reports": "",
    "Coordinating repairs and maintenance requests": "",
    "Assisting tenants with issues or inquiries": "",
    "24/7 emergency response line for tenants": "",
    "Lease renewals and termination management": "",
    "Deposit return management and final inspections": "",
  };
  return (
    <Container>
      <Grid container alignItems="center">
        <Grid item display={"flex"} flexDirection={"column"}>
          <Grid item>
            <SubTitleContents
              title="What’s Included in Our Full Property Management Services?"
              contents=""
            />
          </Grid>
          <Grid item>
            <CheckList_TwoColumns titlesDescriptionsObj={titlesDescriptionsObj} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Full_Section2;
